import {
  CustomCriteriaOnJob,
  CustomCriteriaType,
} from 'server/shared/models/customCriteria';

export type NonDefaultCustomCriteriaRow = {
  label: string;
  toggleValue?: boolean;
  selectText?: string;
};

export function isNonDefaultCustomCriterion(c: CustomCriteriaOnJob): boolean {
  if (c.type === CustomCriteriaType.TOGGLE) {
    return c.value !== c.defaultValueOnJob;
  }
  if (c.type === CustomCriteriaType.SELECT) {
    return (c.values?.length ?? 0) > 0;
  }
  return false;
}

export function toNonDefaultCustomCriteriaRow(
  c: CustomCriteriaOnJob,
): NonDefaultCustomCriteriaRow {
  if (c.type === CustomCriteriaType.TOGGLE) {
    return { label: c.displayName, toggleValue: c.value };
  }
  return {
    label: c.displayName,
    selectText: c.values.map((v) => v.displayName).join(', '),
  };
}
